import { render, staticRenderFns } from "./clients-products-master-input.vue?vue&type=template&id=0f88df1b&scoped=true&"
import script from "./clients-products-master-input.vue?vue&type=script&lang=js&"
export * from "./clients-products-master-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f88df1b",
  null
  
)

export default component.exports